import { render, staticRenderFns } from "./groupF.vue?vue&type=template&id=00a7024c&scoped=true"
import script from "./groupF.vue?vue&type=script&lang=js"
export * from "./groupF.vue?vue&type=script&lang=js"
import style0 from "./groupF.vue?vue&type=style&index=0&id=00a7024c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a7024c",
  null
  
)

export default component.exports